import type { TelemetryLocalStorePort } from '@core/domain/ports/driven/TelemetryLocalStorePort.ts';
import type { TelemetryPort } from '@core/domain/ports/driven/TelemetryPort.ts';
import { NoopTelemetryAdapter } from '../driven/NoopTelemetryAdapter.ts';
import { ObservabilityTelemetryAdapter } from '../driven/ObservabilityTelemetryAdapter.ts';

export type CreateTelemetryOptions = {
  /** In local SQLite mode, persists to `observabilidad_*` tables. */
  localStore?: TelemetryLocalStorePort | null;
};

function createTelemetryAdapter(
  providerRaw: string | undefined,
  localStore?: TelemetryLocalStorePort | null,
): TelemetryPort {
  const provider = providerRaw?.trim().toLowerCase() || 'console';
  if (provider === 'noop' || provider === 'none') return new NoopTelemetryAdapter();
  return new ObservabilityTelemetryAdapter(localStore ?? undefined);
}

/** Pick telemetry adapter by name (tests and callers that do not use {@link createTelemetry}). */
export function selectTelemetryAdapter(raw: string | undefined): TelemetryPort {
  return createTelemetryAdapter(raw);
}

/** Read `TELEMETRY_PROVIDER` from the bundle (Vite) / Vitest. */
export function createTelemetry(options?: CreateTelemetryOptions): TelemetryPort {
  return createTelemetryAdapter(
    import.meta.env.TELEMETRY_PROVIDER as string | undefined,
    options?.localStore,
  );
}
